import { useEffect } from "react";
import "./MenuItem.css";

function MenuItem(menu) {
    return (
        <div
            id="tab-container"
            className="flex flex-col h-full gap-5 px-5 pt-5 pb-20 overflow-auto"
        >
            {menu.menu &&
                menu.menu.map((item) => (
                    <div
                        id="item-container"
                        className="flex flex-row p-3 align-middle border border-black rounded-md shadow-lg md:space-x-4 md:p-5 md:h-fit"
                    >
                        {/* <div className="flex h-20 bg-black w-30 md:h-40 md:w-30" /> */}
                        {item.image !== "" && (
                            <div className="float-left object-cover rounded-sm md:h-30 md:w-1/4">
                                <img id="food-image" src={item.image} />
                            </div>
                        )}
                        <div className="flex flex-col justify-center w-full">
                            <h1
                                id="food-title"
                                className="text-base font-bold md:text-xl"
                            >
                                {item.engName} / {item.vietName}
                            </h1>
                            <p
                                id="food-price"
                                className="text-xs font-medium md:text-lg"
                            >
                                ${item.price.toFixed(2)}
                            </p>
                            <p
                                id="food-description"
                                className="text-xs font-extralight md:text-lg"
                            >
                                {item.description}
                            </p>
                        </div>
                    </div>
                ))}
        </div>
    );
}

export default MenuItem;
